<div class='container pt-5 m-auto pb-5'>
  <div class='d-flex flex-column'>
    <div class='d-flex flex-grow-1 align-content-stretch'>
      <h2 class='text-center m-auto'>
        Select a Plan and let Retreva Introduce you to your Next Customer
      </h2>
      <br />
    </div>
    <div class='d-flex flex-grow-1 mt-5'>
      <div class='row'>
        <div
          *ngFor='let card of pricingCards'
          class='col-md-{{ 12 / pricingCards.length }} mt-5 mt-lg-0'>
          <app-price-card
            [buttons]='card.buttons'
            [color]='card.color'
            [iconName]='card.iconName'
            [info]='card.info'
            [text]='card.text'
            [title]='card.title'></app-price-card>
        </div>
      </div>
    </div>
  </div>
</div>
